import { request } from '@pb/utils'
import { pick } from 'ramda'

import { Offer, ConfiguredOffers, HasVoucherCode, HybrisVouchersRepsonse } from './types'

export const fetchConfiguredOffers = (): Promise<ConfiguredOffers[]> => {
  return request
    .get('member/configuredOffers', {
      type: 'adobe',
    })
    .then((res) => res.data)
}

export const fetchVouchers = (): Promise<Offer[]> =>
  request.get(`vouchers`, { apiVersion: 2 }).then((res) => res.data)

export const postVouchers = <T extends HasVoucherCode>(
  vouchers: T[],
): Promise<HybrisVouchersRepsonse> =>
  request
    .post(`vouchers`, {
      apiVersion: 2,
      data: {
        vouchersList: vouchers.map((voucher: T) =>
          pick(['voucherCode', 'offerKey', 'offerPropositionId', 'offerType'], voucher),
        ),
      },
    })
    .then((res) => res.data)

export const deleteVoucher = (voucherCode: string): Promise<HybrisVouchersRepsonse> =>
  request.delete(`vouchers/${voucherCode}`, { apiVersion: 2 }).then((res) => res.data)
